import { getFlangeMaterialAttrs } from "./legacy/materialDBController/getFlangeMaterialAttrs.func";
import { getPadMaterialAttrs } from "./legacy/materialDBController/getPadsMaterialAttrs.func";
import { getPipeMaterialAttrs } from "./legacy/materialDBController/getPipeMaterialAttrs.func";
import { getShellMaterialAttrs } from "./legacy/materialDBController/getShellMaterialAttrs.func";
import { roundToTwo } from "./calculation";
import { queryPvDb, QueryTypes } from "./sqliteApi";

// check if value for a given column already exists
const checkIfValueExists = (material_code, array, column) => {
  array.forEach((element) => {
    if (material_code === "EHV601ABPAN1") console.log(element, column);
    if (element.Code && element.Code === material_code) {
      if (element[column]) return element[column];
    }
  });
};

// Gets all estimations and combines to show in estimation table
export const EstimationSummary2 = async (input) => {
  var result = [];
  let totalPaint = 0;
  // console.log("input", input);
  // console.log("DGV5 inputs ", input["DataGridView5"]);
  try {
    const materialCostQuery = async (component) => {
      var cost = await queryPvDb(
          "SELECT `Material Cost / Unit` FROM `Material_Cost_Unit_` WHERE Components = '" +
            component +
            "' LIMIT 1",
          { type: QueryTypes.SELECT }
        )
        .then((res) => {
          if (res[0]) {
            return roundToTwo(res[0]["Material Cost / Unit"]);
          } else return 0;
        })
        .catch((error) => {
          return null;
        });

      return cost;
    };

    const fabHoursRateQuery = async (component) => {
      var rate = await queryPvDb(
          "SELECT `Fab Rate / Hr` FROM `Fab_Rate_Hr` WHERE Components = '" +
            component +
            "' LIMIT 1",
          { type: QueryTypes.SELECT }
        )
        .then((res) => {
          console.log("res:", component, res);
          if (res[0]) {
            return roundToTwo(res[0]["Fab Rate / Hr"]);
          } else return 0;
        })
        .catch((error) => {
          return null;
        });

      return rate;
    };

    const shellData = input.DataGridView5;
    const nozzlesData = input.DataGridView1;
    const geometryData = input.DataGridView10;

    let equip = 1234; //giving random value here as it wont be used
    let project = 1234; //giving random value here as it wont be used

    console.log("going ot get mc", input.ComboBox_HeadReq);
    const shellMaterials = await Promise.all(
      shellData.map(async (m, i) => {
        return await getShellMaterialAttrs({
          project,
          equip,
          material: m,
          data: input,
          index: i,
        });
      })
    );

    console.log("sehlld one");

    const pipesMaterials = //[];
      await Promise.all(
        nozzlesData.map(async (m, i) => {
          return await getPipeMaterialAttrs({
            project,
            equip,
            material: m,
            geometry: geometryData[i],
            data: input,
            dataWithEstimations: input,
            i,
          });
        })
      );
    const flangesMaterials = //[];
      await Promise.all(
        nozzlesData.map(async (m, i) => {
          return await getFlangeMaterialAttrs({
            project,
            equip,
            material: m,
            geometry: geometryData[i],
            data: input,
            dataWithEstimations: input,
            i,
          });
        })
      );
    const padsMaterials = //[];
      await Promise.all(
        nozzlesData
          .filter((m) => ![0, "0", "-"].includes(m["Pad OD"]))
          .map(async (m, i) => {
            return await getPadMaterialAttrs({
              project,
              equip,
              material: m,
              geometry: geometryData[i],
              data: input,
              dataWithEstimations: input,
              i,
            });
          })
      );

    let materials = [
      ...shellMaterials,
      ...pipesMaterials,
      ...flangesMaterials,
      ...padsMaterials,
    ];

    console.log({ materials });
    let ungroupedMaterialsList = [];

    // Create a Map to store accumulated quantities for each code
    const groupMaterialsMap = new Map();

    // materials.forEach(async material => {
    const processMaterial = async (material) => {
      let tempObject = {};
      tempObject["Code"] = material["material_code"];
      tempObject["Component"] = material["component_type"];
      tempObject["Description"] = material["description"];
      tempObject["Bom Adder"] =
        input?.DataGridView8?.[result.length]?.["Bom Adder"] || "";
      tempObject["Qty"] = material["qty"];
      tempObject["Measure/Wt"] = roundToTwo(material.specs?.Weight);
      tempObject["Unit"] = "kg";

      let component = material["component_name"];
      if (component === "head" || component === "shell")
        component = component.charAt(0).toUpperCase() + component.slice(1);
      else if (component === "Pipe")
        component = `${component} ${material.specs?.Size}"`;
      else if (component === "Flange")
        component = `Nozzle ${material.specs?.Size}"`;

      // tempObject["Material Cost/ Unit"] = input?.DataGridView8?.[result.length]?.["Material Cost/ Unit"] || (await materialCostQuery(component)) || 75;
      tempObject["Material Cost/ Unit"] =
        checkIfValueExists(
          material["material_code"],
          input?.DataGridView8,
          "Material Cost/ Unit"
        ) ||
        (await materialCostQuery(component)) ||
        75;
      tempObject["Material Cost"] = roundToTwo(
        tempObject["Measure/Wt"] * tempObject["Material Cost/ Unit"]
      );
      tempObject["FAB Hours"] = parseFloat(material.specs?.Fab_Hours) || 5;
      // tempObject["FAB Rate/Hr"] = checkIfValueExists(material["material_code"], input?.DataGridView8, "FAB Rate/Hr") || 75;
      tempObject["FAB Rate/Hr"] = 75;
      tempObject["FAB Cost"] =
        input.DataGridView8?.[result.length]?.["FAB Cost"] || "";
      tempObject["Remarks"] =
        input.DataGridView8?.[result.length]?.["Remarks"] || "";

      totalPaint += roundToTwo(tempObject["Measure/Wt"]);

      // Check if the code already exists in the Map
      if (groupMaterialsMap.has(tempObject["Code"])) {
        // If yes, update the existing entry
        const existingMaterial = groupMaterialsMap.get(tempObject["Code"]);
        existingMaterial.Qty += tempObject["Qty"];
        existingMaterial["FAB Hours"] += tempObject["FAB Hours"];
        existingMaterial["Measure/Wt"] += tempObject["Measure/Wt"];
      } else {
        // If no, add a new entry
        groupMaterialsMap.set(tempObject["Code"], { ...tempObject });
      }

      // Push the current material to the ungrouped list
      ungroupedMaterialsList.push(tempObject);
    };

    // Process materials asynchronously
    await Promise.all(materials.map(processMaterial));

    const groupedArray = Array.from(groupMaterialsMap.values());
    result = [...result, ...groupedArray];

    console.log({ ungroupedMaterialsList });
    console.log({ groupedArray, result });

    console.log("material_code__", result);
    //NDT Long Weld
    let NDTLong = {};
    NDTLong["Code"] = "";
    NDTLong["Component"] = "NDT";
    NDTLong["Description"] = NDTLong["Component"] + " (Long Weld)";
    NDTLong["Bom Adder"] = "";
    NDTLong["Qty"] = 1;
    NDTLong["Measure/Wt"] = roundToTwo(input?.txt_SF / 1000);
    NDTLong["Unit"] = "m";
    NDTLong["Material Cost/ Unit"] =
      input?.DataGridView8?.[result.length]?.["Material Cost/ Unit"] ||
      (await materialCostQuery("NDT")) ||
      78;
    // NDTLong["Override Cost"] =
    //   input?.DataGridView8?.[result.length]?.["Override Cost"] || "";
    NDTLong["Material Cost"] = roundToTwo(
      NDTLong["Measure/Wt"] * NDTLong["Material Cost/ Unit"]
    );
    NDTLong["FAB Hours"] = input?.DataGridView7?.reduce(
      (acc, curr) => acc + parseFloat(curr?.["Long_Weld_Hours"] || 0),
      0
    );
    NDTLong["FAB Rate/Hr"] =
      input.DataGridView8?.[result.length]?.["FAB Rate/Hr"] ||
      (await fabHoursRateQuery("NDT"));
    NDTLong["FAB Cost"] =
      input.DataGridView8?.[result.length]?.["FAB Cost"] || "";
    // NDTLong["Other Cost"] = 0
    // // NDTLong["Total Cost"] =  NDTLong["Material Cost"] + NDTLong["Other Cost"]
    NDTLong["Remarks"] =
      input?.DataGridView8?.[result.length]?.["Remarks"] || "";
    result.push(NDTLong);
    console.log("NDTLong");

    //////////////////////
    //NDT Circ Weld
    let NDTCirc = {};
    NDTCirc["Code"] = "";
    NDTCirc["Component"] = "NDT";
    NDTCirc["Description"] = NDTCirc["Component"] + " Circ Weld";
    NDTCirc["Bom Adder"] = "";
    NDTCirc["Qty"] = 1;
    NDTCirc["Measure/Wt"] = 2.7;
    // roundToTwo(((Math.PI * input.txtVIDia) / 1000) *
    //   (input.DataGridView5.length - 2));
    NDTCirc["Unit"] = "m";
    NDTCirc["Material Cost/ Unit"] =
      input?.DataGridView8?.[result.length]?.["Material Cost/ Unit"] ||
      (await materialCostQuery("NDT")) ||
      78;
    // NDTCirc["Override Cost"] =
    //   input.DataGridView8?.[result.length]?.["Override Cost"] || "";
    NDTCirc["Material Cost"] = roundToTwo(
      NDTCirc["Measure/Wt"] * NDTCirc["Material Cost/ Unit"]
    );
    NDTCirc["FAB Hours"] = input?.DataGridView7?.reduce(
      (acc, curr) => acc + parseFloat(curr?.["Circ_Weld_Hours"] || 0),
      0
    );
    NDTCirc["FAB Rate/Hr"] =
      input.DataGridView8?.[result.length]?.["FAB Rate/Hr"] ||
      (await fabHoursRateQuery("NDT"));
    NDTCirc["FAB Cost"] =
      input.DataGridView8?.[result.length]?.["FAB Cost"] || "";
    // NDTCirc["Other Cost"] = 0
    NDTCirc["Remarks"] =
      input.DataGridView8?.[result.length]?.["Remarks"] || "";
    result.push(NDTCirc);
    console.log("NDTCirc");

    //Paint
    let Paint = {};
    // let totalWe
    Paint["Code"] = "";
    Paint["Component"] = "Paint";
    Paint["Description"] = Paint["Component"] + " External Surface Area (m^2)";
    Paint["Bom Adder"] = "";
    Paint["Qty"] = 1;
    Paint["Measure/Wt"] = roundToTwo(totalPaint); //sum of all weightts in result.length-2
    Paint["Unit"] = "m^2";
    Paint["Material Cost/ Unit"] =
      input?.DataGridView8?.[result.length]?.["Material Cost/ Unit"] ||
      (await materialCostQuery("Paint")) ||
      3;
    // Paint["Override Cost"] =
    //   input.DataGridView8?.[result.length]?.["Override Cost"] || "";
    Paint["Material Cost"] = roundToTwo(
      Paint["Measure/Wt"] * Paint["Material Cost/ Unit"]
    );
    Paint["FAB Hours"] = 0;
    Paint["FAB Rate/Hr"] =
      input.DataGridView8?.[result.length]?.["FAB Rate/Hr"] ||
      (await fabHoursRateQuery("Paint"));
    Paint["FAB Cost"] =
      input.DataGridView8?.[result.length]?.["FAB Cost"] || "";
    // Paint["Other Cost"] = 0
    Paint["Remarks"] = input.DataGridView8?.[result.length]?.["Remarks"] || "";
    result.push(Paint);
    console.log("Paitn");

    //Hydrotest
    let Hydrotest = {};
    Hydrotest["Code"] = "";
    Hydrotest["Component"] = "Hydrotest";
    Hydrotest["Description"] = Hydrotest["Component"] + " Material & Man-Hours";
    Hydrotest["Bom Adder"] = "";
    Hydrotest["Qty"] = 1;
    Hydrotest["Measure/Wt"] = "200";
    Hydrotest["Unit"] = "hr";
    Hydrotest["Material Cost/ Unit"] =
      input?.DataGridView8?.[result.length]?.["Material Cost/ Unit"] ||
      (await materialCostQuery("Hydrotest")) ||
      1;
    Hydrotest["Material Cost"] = roundToTwo(
      Hydrotest["Measure/Wt"] * Hydrotest["Material Cost/ Unit"]
    );
    Hydrotest["FAB Hours"] = 10;
    Hydrotest["FAB Rate/Hr"] =
      input.DataGridView8?.[result.length]?.["FAB Rate/Hr"] ||
      (await fabHoursRateQuery("Hydrotest"));
    Hydrotest["FAB Cost"] =
      input.DataGridView8?.[result.length]?.["FAB Cost"] || "";
    // Hydrotest["Other Cost"] = 0
    // Hydrotest["Total Cost"] = Hydrotest["Material Cost"] + Hydrotest["Other Cost"]
    Hydrotest["Remarks"] =
      input.DataGridView8?.[result.length]?.["Remarks"] || "";
    result.push(Hydrotest);

    console.log("Hydrotest");

    let cost = result.reduce(
      (accumulator, currentValue) => accumulator + currentValue["FAB Hours"],
      0
    );
    console.log("cost", input.TextBox35, cost);
    cost = roundToTwo(cost * (input.TextBox35 ?? 0));

    //return the object
    // console.log("res inside", result)
    return [result, cost];
  } catch (err) {
    console.error(err);
  }
};

const queryMaker = async (selector, table, colValue, rowValue, name) => {
  let column = "";

  await queryPvDb(`PRAGMA table_info("${table}")`, { type: QueryTypes.SELECT })
    .then((response) => {
      // response[i].name is the column name
      if (response.length > 0) {
        column = response
          .map((r) => r.name)
          .sort(
            (a, b) =>
              Math.abs(Number(a) - colValue) - Math.abs(Number(b) - colValue)
          )[0];
      }
    })
    .catch(() => {
      column = undefined;
    });

  return await queryPvDb(
      "SELECT `" +
        column +
        "` FROM `" +
        table +
        "` ORDER BY ABS(`" +
        selector +
        "` - " +
        parseInt(rowValue) +
        ") LIMIT 1",
      { type: QueryTypes.SELECT }
    )
    .then((response) => {
      console.log("estimate of name:", response[0][column]);
      return response[0][column];
    })
    .catch((error) => {
      return undefined;
    });
};

export const estimateSaddle = async (input) => {
  let DataGridView13 = [];

  var shell_thickness = input["DataGridView5"][1]["Provided Thickness"];
  var diameter = input["DataGridView5"][1]["Diameter"];
  var size = input.TxtBx_VOD / 25.4; //to be changed

  //Row 1 - Saddle
  DataGridView13.push({}); //
  console.log("DataGridView", DataGridView13);
  DataGridView13[0]["Item"] = "Saddle";
  DataGridView13[0]["Qty"] = 2;
  DataGridView13[0]["Material Cost/KG"] = await queryPvDb(
      "SELECT `Material Cost` FROM `Material Cost` WHERE Component =  'Saddle' AND Material = '" +
        input.ComboBox9 +
        "' LIMIT 1",
      { type: QueryTypes.SELECT }
    )
    .then((res) => roundToTwo(res[0]["Material Cost"]))
    .catch((error) => {
      return null;
    });
  console.log(DataGridView13[0]["Material Cost/KG"]);
  DataGridView13[0]["Weight"] = await queryPvDb(
      "SELECT `Weight (Kg)` FROM `Saddle Weight` ORDER BY ABS(`Size (inch)` - " +
        parseInt(size) +
        ") LIMIT 1",
      { type: QueryTypes.SELECT }
    )
    .then((res) => roundToTwo(res[0]["Weight (Kg)"]));
  DataGridView13[0]["Man-Hours"] = await queryPvDb(
      "SELECT `Hours` FROM `Saddles Manhours` ORDER BY ABS(`Vessel Dia, mm` - " +
        parseInt(diameter) +
        ") LIMIT 1",
      { type: QueryTypes.SELECT }
    )
    .then((res) => roundToTwo(res[0]["Hours"]))
    .catch((error) => {
      return null;
    });
  DataGridView13[0]["Material Cost"] = roundToTwo(
    DataGridView13[0]["Weight"] * DataGridView13[0]["Material Cost/KG"]
  );
  DataGridView13.push({});

  //Row 2 - Wear Plate
  DataGridView13[1]["Item"] = "Saddle Wear Plate";
  DataGridView13[1]["Qty"] = 2;
  DataGridView13[1]["Material Cost/KG"] = await queryPvDb(
      "SELECT `Material Cost` FROM `Material Cost` WHERE Component =  'Saddle' AND Material = '" +
        input.ComboBox9 +
        "' LIMIT 1",
      { type: QueryTypes.SELECT }
    )
    .then((res) => roundToTwo(res[0]["Material Cost"]))
    .catch((error) => {
      return null;
    });
  DataGridView13[1]["Weight"] = await queryPvDb(
      "SELECT `Weight (Kg)` FROM `Wearplate Weight` ORDER BY ABS(`Size (inch)` - " +
        parseInt(size) +
        ") LIMIT 1",
      { type: QueryTypes.SELECT }
    )
    .then((res) => res[0]["Weight (Kg)"])
    .catch((error) => {
      return null;
    });
  DataGridView13[1]["Man-Hours"] = await queryMaker(
    "Shell Thk, mm",
    "Saddle Wear Plates",
    shell_thickness,
    diameter,
    ""
  );
  DataGridView13[1]["Material Cost"] = roundToTwo(
    DataGridView13[1]["Weight"] * DataGridView13[1]["Material Cost/KG"]
  );

  return DataGridView13;
};

export const estimateNozzle = async (input) => {
  const diameter1 = 0.001476;
  let thickness;
  let diameter;

  const queryMaker = async (selector, table, colValue, rowValue, name) => {
    // Helpers to derive numeric values from labels and inputs
    const toNumberStrict = (val) => {
      const n = typeof val === "number" ? val : parseFloat(String(val));
      return Number.isFinite(n) ? n : NaN;
    };
    const numericFromLabel = (label) => {
      if (typeof label === "number") return label;
      if (!label) return NaN;
      let s = String(label).trim();
      s = s.replace(/"/g, "").replace(/–|-/g, " ");
      // Handle mixed numbers like 2 1/2 or 2-1/2
      const mixed = s.match(/^(\d+)\s*(?:-|\s)?(\d+)\/(\d+)$/);
      if (mixed) {
        const base = parseFloat(mixed[1]);
        const num = parseFloat(mixed[2]);
        const den = parseFloat(mixed[3]);
        const res = base + num / den;
        return Number.isFinite(res) ? res : NaN;
      }
      // Handle pure fractions like 1/2
      const frac = s.match(/^(\d+)\/(\d+)$/);
      if (frac) {
        const num = parseFloat(frac[1]);
        const den = parseFloat(frac[2]);
        const res = num / den;
        return Number.isFinite(res) ? res : NaN;
      }
      // Extract first decimal/integer occurrence (e.g., DN50 -> 50, Sch. 40 -> 40)
      const m = s.match(/\d+(?:\.\d+)?/);
      if (m) {
        const res = parseFloat(m[0]);
        return Number.isFinite(res) ? res : NaN;
      }
      return NaN;
    };

    console.log("selector", selector, table, colValue, rowValue);
    const colTarget = toNumberStrict(colValue);
    let valueColumn = null;
    let selectorColumn = null;
    let rowNumeric = numericFromLabel(rowValue);

    await queryPvDb(`PRAGMA table_info("${table}")`, { type: QueryTypes.SELECT })
      .then((response) => {
        if (!response || !response.length) return;
        const names = response.map((r) => r.name);
        // Resolve selector column (case-insensitive, try synonyms)
        const synonyms = [selector, "Pipe Size", "Nozzle Size", "Size", "Diameter", "Dia", "Class"];
        selectorColumn = names.find(
          (n) => synonyms.some((syn) => String(n).toLowerCase() === String(syn).toLowerCase())
        );
        if (!selectorColumn) selectorColumn = names[0];

        // Resolve value column based on closest numeric match to colValue
        const candidates = names
          .filter((n) => n !== selectorColumn)
          .map((n) => ({ name: n, value: numericFromLabel(n) }))
          .filter((x) => Number.isFinite(x.value));

        if (Number.isFinite(colTarget) && candidates.length) {
          const aboveOrEqual = candidates
            .filter((c) => c.value >= colTarget)
            .sort((a, b) => a.value - b.value);

          if (aboveOrEqual.length) {
            valueColumn = aboveOrEqual[0].name;
          } else {
            candidates.sort((a, b) => b.value - a.value);
            valueColumn = candidates[0].name;
          }
        } else if (candidates.length) {
          valueColumn = candidates[candidates.length - 1].name;
        } else {
          valueColumn = names.find((n) => n !== selectorColumn) || names[0];
        }

        console.log("selectorColumn", selectorColumn, "valueColumn", valueColumn);
      })
      .catch((error) => {
        console.error(error);
        valueColumn = null;
        selectorColumn = null;
      });

    if (!valueColumn || !selectorColumn) {
      console.warn(`[PV] queryMaker: cannot resolve columns for '${table}'.`);
      return null;
    }

    if (!Number.isFinite(rowNumeric)) rowNumeric = toNumberStrict(rowValue);
    if (!Number.isFinite(rowNumeric)) rowNumeric = 0;

    return await queryPvDb(
        "SELECT `" +
          valueColumn +
          "` FROM `" +
          table +
          "` ORDER BY ABS(`" +
          selectorColumn +
          "` - " +
          rowNumeric +
          ") ASC, `" +
          selectorColumn +
          "` ASC LIMIT 1",
        { type: QueryTypes.SELECT }
      )
      .then((response) => {
        if (!response || !response.length) return null;
        console.log(response[0]);
        console.log("estimate of name:", response[0][valueColumn]);
        return response[0][valueColumn];
      })
      .catch((error) => {
        console.error("[PV] queryMaker failed:", error);
        return null;
      });
  };

  function roundToTwo(num, decimalPlaces = 2) {
    num = Math.round(num + "e" + decimalPlaces);
    return Number(num + "e" + -decimalPlaces);
  }

  // --- Per-row helpers to keep estimateNozzle readable ---

  const getPadWeight = async (pipeSize, padOD) => {
    if (padOD == 0) return 0;

    const rows = await queryPvDb(
        'SELECT `Weight` FROM `pad weight` WHERE `Size` = "' +
          pipeSize +
          '" LIMIT 1',
        { type: QueryTypes.SELECT }
      )
      .catch(() => []);

    if (!rows.length) return "Db Error";

    const val = Number(rows[0]["Weight"]);
    return Number.isFinite(val) ? roundToTwo(val) : "Db Error";
  };

  const getPipeWeight = async (pipeSize) => {
    const rows = await queryPvDb(
        'select `Weight` from `pipe weight` where `Size` = "' +
          pipeSize +
          '" LIMIT 1',
        { type: QueryTypes.SELECT }
      )
      .catch(() => []);

    if (!rows.length) return "Db Error";

    const val = Number(rows[0]["Weight"]);
    return Number.isFinite(val) ? roundToTwo(val) : "Db Error";
  };

  const getFlangeWeight = async (pipeSize, flangeRating) => {
    if (flangeRating === "-") return 0;

    const rows = await queryPvDb(
        'select `Weight` from `flange weight` where `Size` = "' +
          pipeSize +
          '" LIMIT 1',
        { type: QueryTypes.SELECT }
      )
      .catch(() => []);

    if (!rows.length) return "Db Error";

    const val = Number(rows[0]["Weight"]);
    return Number.isFinite(val) ? roundToTwo(val) : "Db Error";
  };

  const getNozzleManHours = async (pipeSize, safeThickness) => {
    const response = await queryMaker(
      "Nozzle Size",
      "nozzle weld",
      safeThickness,
      pipeSize,
      ""
    ).catch(() => null);

    const val = Number(response);
    return Number.isFinite(val) ? roundToTwo(val) : "Db Error";
  };

  const getBoltupHours = async (pipeSize, safeClass) => {
    const response = await queryMaker(
      "Class",
      "bolt up hours",
      safeClass,
      pipeSize,
      ""
    ).catch(() => null);

    const val = Number(response);
    return Number.isFinite(val) ? roundToTwo(val) : "Db Error";
  };

  const getPipeWeldHours = async (pipeSize, safeThickness) => {
    const response = await queryMaker(
      "Pipe Size",
      "pipe weld",
      safeThickness,
      pipeSize,
      ""
    ).catch(() => null);

    const val = Number(response);
    return Number.isFinite(val) ? roundToTwo(val) : "Db Error";
  };

  const getPadWeldHours = async (pipeSize, safeThickness) => {
    const response = await queryMaker(
      "Pad Size",
      "pad weld",
      safeThickness,
      pipeSize,
      ""
    ).catch(() => null);

    const val = Number(response);
    return Number.isFinite(val) ? roundToTwo(val) : "Db Error";
  };

  // Loop through each nozzle row (DataGridView1) and build the corresponding
  // output row (DataGridView2) with all weights and man-hours.
  const promises = input["DataGridView1"].map(async (elem, index) => {
    const tempObject = {};

    // Thickness/diameter reference (current logic: always from first shell row)
    if (input["DataGridView1"][index][0] === "Inlet") {
      thickness = input["DataGridView5"][0]["Provided Thickness"];
      diameter = input["DataGridView5"][0]["Diameter"];
    } else {
      thickness = input["DataGridView5"][0]["Provided Thickness"];
      diameter = input["DataGridView5"][0]["Diameter"];
    }

    const Pipe_Size = elem["Size"];
    const Nozzle_Class = elem["Flange Rating"];

    const safeThickness =
      Number.isFinite(Number(thickness)) && Number(thickness) > 0
        ? Number(thickness)
        : 6.4;
    const safeClass = Number.isFinite(Number(Nozzle_Class))
      ? Number(Nozzle_Class)
      : 150;

    const padOD = elem["Pad OD"];
    const padThk = elem["Pad Thk"];
    const hasPad =
      !(
        Number(padOD) === 0 ||
        padOD === "" ||
        padOD === null ||
        padOD === undefined
      ) ||
      !(
        Number(padThk) === 0 ||
        padThk === "" ||
        padThk === null ||
        padThk === undefined
      );

    // Run all lookups in parallel for this nozzle row
    const [
      padWeight,
      pipeWeight,
      flangeWeight,
      nozzleHours,
      boltupHours,
      padWeldHours,
      pipeWeldHours,
    ] = await Promise.all([
      getPadWeight(Pipe_Size, padOD),
      getPipeWeight(Pipe_Size),
      getFlangeWeight(Pipe_Size, Nozzle_Class),
      getNozzleManHours(Pipe_Size, safeThickness),
      getBoltupHours(Pipe_Size, safeClass),
      hasPad ? getPadWeldHours(Pipe_Size, safeThickness) : Promise.resolve(0),
      getPipeWeldHours(Pipe_Size, safeThickness),
    ]);

    tempObject["Flange Weight"] = flangeWeight;
    tempObject["Pipe Weight"] = pipeWeight;
    tempObject["Pad Weight"] = padWeight;
    tempObject["Nozzle Weld Hours"] = nozzleHours;
    tempObject["Pipe Weld Hours"] = pipeWeldHours;
    tempObject["Pad Weld Hours"] = padWeldHours;
    tempObject["Bolt-up Hours"] = boltupHours;

    // NDT Cost: placeholder (0) until logic is implemented
    tempObject["NDT Cost"] = 0;

    return tempObject;
  });

  const DataGridView2 = await Promise.all(promises).catch((error) => {
    console.log("An error occurred while running the queries:", error);
    return [];
  });

  console.log("response", DataGridView2);

  return DataGridView2;
};
